import { render, staticRenderFns } from "./RoleAndPermissions.vue?vue&type=template&id=0f8d1b00&scoped=true&"
import script from "./RoleAndPermissions.vue?vue&type=script&lang=js&"
export * from "./RoleAndPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8d1b00",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VDivider,VIcon,VList,VListItem,VListItemContent,VListItemIcon,VListItemTitle})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f8d1b00')) {
      api.createRecord('0f8d1b00', component.options)
    } else {
      api.reload('0f8d1b00', component.options)
    }
    module.hot.accept("./RoleAndPermissions.vue?vue&type=template&id=0f8d1b00&scoped=true&", function () {
      api.rerender('0f8d1b00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/components/Profile/RoleAndPermissions.vue"
export default component.exports